import { useParams } from 'react-router-dom';

import { useAccountState } from 'contexts/account/account-context';

import LoadingSpinner from 'components/loading-spinner';

import Paper from 'components/paper';
import { useMemo } from 'react';
import { useSiteSettingsState } from 'views/site-settings/context/site-settings-context';
import LongitudeLatitude from './components/longitude-latitude';
import TemperatureProfile from './components/temperature-profile/temperature-profile';
import { Grid } from '@mui/material';

type ParamTypes = {
  globalSiteId: string;
  siteTab: string;
};

type Props = {};

const GeneralSettings: React.FC<Props> = ({}) => {
  const params = useParams<ParamTypes>();
  const { account } = useAccountState();
  const {
    featuresQuery: { isLoading },
    access,
  } = useSiteSettingsState();

  // #region STATES
  const site = useMemo(() => {
    return account.company?.addressAccess.find((site) => site.id === params.globalSiteId);
  }, [account, params.globalSiteId]);
  // #endregion STATES

  if (isLoading) return <LoadingSpinner />;

  return (
    <Grid container gap={4}>
      <Grid size={12}>
        <Paper
          transparent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
          }}>
          {access.hasTemperatureAccess && <TemperatureProfile />}
          <LongitudeLatitude site={site} />
        </Paper>
      </Grid>
    </Grid>
  );
};

export default GeneralSettings;
